module.exports = __webpack_public_path__ + "img/rojo.28b4ee73.png";